






import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const AppStore = namespace("App");

@Component({
  name: "Spinner"
})
export default class Spinner extends Vue {
  @AppStore.State
  public axiosLoading!: number;

  get loading(): boolean {
    return this.axiosLoading ? true : false;
  }

  @Watch("loading")
  setLoading(loading: boolean) {
    const modals = document.getElementsByClassName("modal-dialog");
    for (const modal of modals) {
      if (loading) {
        modal.classList.add("loading");
      } else {
        modal.classList.remove("loading");
      }
    }
  }
}
